export class MedicationDetail {
    name:string = "";
    route:string = "";
    dose:number = 0;
}

export function DefaultMedicationDetail(): MedicationDetail{
    return {name:'', route:'', dose:0}
}